import React, { useState } from "react";
import { Redirect } from "react-router";
import styled, { css } from "styled-components";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row, Text, Img } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { faSpotify, faYoutube } from "@fortawesome/free-brands-svg-icons";

const TextContainer = styled(Row)`
  padding: 0px 10px;
  align-items: center;
  color: ${({ theme }) => theme.textColor.light};
`;

const ListItem = styled.li`
  display: inline-block;
  *display: inline; /*IE7*/
  *zoom: 1; /*IE7*/
`;

const IconText = ({ icon, text }) => {
  return (
    <TextContainer>
      <FontAwesomeIcon
        style={{
          fontSize: "16px",
          color: Theme.textColor.light,
          margin: "5px",
        }}
        icon={icon}
      />
      <Text
        fontFamily={Theme.fontFamily.recursive}
        fontWeight={600}
        color={Theme.color.GRAY_0}
        fontSize="18px"
        textAlign="left"
        marginLeft="8px"
      >
        {text}
      </Text>
    </TextContainer>
  );
};

const StyledText = styled(Text)`
  font-family: ${({ theme }) => theme.fontFamily.recursive};
  ${({ theme }) =>
    css`
      font-family: ${theme.fontFamily.recursive};
      color: ${theme.color.GRAY_1};
      &:hover {
        color: ${theme.color.GRAY_1};
      }
    `}
  font-weight: 600;
  font-size: 16px;
  text-align: left;
  margin-left: 8px;
`;

export default () => {
  const [redirectTo, setRedirect] = useState("");

  return (
    <Col style={{ width: "92%", marginTop: "20px" }}>
      <IconText text="Import videos/playlists from youtube." icon={faYoutube} />
      <ul style={{ color: Theme.textColor.light }}>
        <li>
          <StyledText>{"Resource should be public"} </StyledText>
        </li>
        <li>
          <StyledText>
            {`URL should be of type : https://www.youtube.com/watch?v=<video_id> OR https://www.youtube.com/playlist?list=<playlist_id>`}
          </StyledText>
        </li>
      </ul>
      <IconText text="Import songs/playlists from Spotify." icon={faSpotify} />
      <ul style={{ color: Theme.textColor.light }}>
        <li>
          <StyledText>{"Resource should be public"}</StyledText>
        </li>
        <li>
          <StyledText>
            {`URL should be of type : https://open.spotify.com/track/<track_id>, https://open.spotify.com/playlist/<playlist_id>`}
          </StyledText>
        </li>
        <li>
          <StyledText
            style={{ cursor: "pointer" }}
            onClick={() => {
              setRedirect("/account");
            }}
          >
            {
              "Make sure you have connected your spotify, google account to import from spotify"
            }
          </StyledText>
        </li>
      </ul>
      {redirectTo && <Redirect push to={redirectTo} />}
    </Col>
  );
};
